export { default } from './fetchJSON'
